import React from "react"
import { Flex, FlexProps } from "@chakra-ui/core"
import ReactPlayer from "react-player"

type EmbedProps = FlexProps & {
  code: string
  responsive?: boolean
}

export default function ProductVideoEmbed({
  code,
  responsive = false,
  ...props
}: EmbedProps) {
  return (
    <ReactPlayer
      url={code}
      width="350px"
      height="200px"
      controls={true}
      config={{
        youtube: {
          playerVars: { showinfo: 1 },
        },
        vimeo: {
          playerOptions: { controls: true, dnt: 1 },
        },
      }}
    />
  )
}
